import { Component, OnInit } from '@angular/core';
import { HeaderData } from '../../header/headerData';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Module } from '../../_models/module';
import { ToastsManager } from 'ng2-toastr';
import { Log } from 'ng2-logger';
import { environment } from '../../../environments/environment';
import { ACLFeature } from '../../_models/acl-feature';
import {TagFamily} from '../../_models/tagFamily';
import {SelectCompany} from '../../management/components/impersonate/selectCompany';

const log = Log.create('ModuleDetail');
@Component({
  moduleId: module.id,
  selector: 'edit-module',
  styleUrls: ['module.less'],
  templateUrl: 'module.component.html',
})
export class ModuleComponent implements OnInit {
  headerData: HeaderData = new HeaderData('*Modulename here*');
  module: Module = new Module;
  isVisible: any;
  possibleCapabilities: any;
  possibleVoltageTypes: any;
  possibleModuleFamilies: any;
  possibleModuleFamilyNames: any;
  parentId: number;
  parentParams: any;
  id: number;
  urlOptions: any = {};

  iCanMaintenanceMode: boolean = true;
  readOnly: boolean = true;
  iCanArchive: boolean = false;
  iCanViewArchive: boolean = false;
  iCanReadTags: boolean = false;
  iCanWriteTags: boolean = false;

  tagFamilies: Array<any> = [];
  activeTagFamily: any = null;
  tags: Array<any> = [];

  piPoDates: Array<any> = [];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private admin: AdminService,
              private toast: ToastsManager ) {}

  ngOnInit() {

    this.admin.canI(ACLFeature.MAINTENANCE_MODE_ADMIN).subscribe((iCan: boolean) => {
      this.iCanMaintenanceMode = iCan;
    });

    this.admin.canI(ACLFeature.VIEW_ARCHIVE_IN_ADMIN).subscribe((iCan: boolean) => {
      this.iCanViewArchive = iCan;
    });

    this.admin.canI(ACLFeature.ARCHIVE).subscribe((iCan: boolean) => {
      this.iCanArchive = iCan;
    });

    this.admin.canI(ACLFeature.WRITE_MODULES).subscribe((iCan: boolean) => {
      this.readOnly = !iCan;
    });

    this.admin.canI(ACLFeature.WRITE_TAGS).subscribe((iCan: boolean) => {
      this.iCanWriteTags = iCan;
    });

    this.admin.canI(ACLFeature.READ_TAGS).subscribe((iCan: boolean) => {
      this.iCanReadTags = iCan;
    });

    this.module.family = {};
    this.module.housing = {};

    // get module controller data
    this.route.params.subscribe(params => {
      this.admin.getModuleController(params['id']).subscribe((response) => {

        log.d('module router params', params);

        this.parentParams = this.route.snapshot.parent.params;
        this.parentId = Number(this.route.snapshot.parent.params['parentId']);
        this.urlOptions.parentId = this.parentId;
        this.id = Number(this.route.snapshot.params['id']);
        this.module = response.data;

        log.d('getModuleController response', response);

        this.admin.getModuleCapabilities().subscribe((res) => {
            log.d('getModuleCapabilities', res.data);
            this.possibleCapabilities = res.data;
        });

        this.admin.getModuleFamilies().subscribe((res) => {
          log.d('getModuleFamilies', res.data);

          this.possibleModuleFamilyNames = res.data.map(family => {
            return {
              id: family.id,
              text: family.treeName
            };
          });
          this.possibleModuleFamilies = res.data;
        });

        this.admin.getModuleVoltageTypes().subscribe((res) => {
          this.possibleVoltageTypes = res.data;
        });

        this.admin.getTagFamiliesController().subscribe((res) => {
          this.tagFamilies = res.map((item) => {
            return {id: item.id, text: item.name};
          });

          if (this.tagFamilies.length > 0) {
            this.selectedModuleTagFamily(this.tagFamilies[0]);
          }
        });
      });
    });
  }

  public selectedModuleTagFamily(tagFamily) {
    this.admin.getTagFamilyController(tagFamily.id).subscribe((res) => {
      this.activeTagFamily = { id: res.id, text: res.name };
      this.tags = res.tags;
    });
  }

  public selectedModuleFamilyId(value)    { this.setModuleFamilyName(value, 'family'); }
  public selectedModuleFamilyNaId(value)  { this.setModuleFamilyName(value, 'familyNa'); }
  public selectedModuleFamilySaId(value)  { this.setModuleFamilyName(value, 'familySa'); }
  public selectedModuleFamilyCnId(value)  { this.setModuleFamilyName(value, 'familyCn'); }
  public selectedModuleFamilyRoaId(value) { this.setModuleFamilyName(value, 'familyRoa'); }

  public setModuleFamilyName(value, modelName) {
    const moduleFamilyIndex = this.possibleModuleFamilies.findIndex(family => family.id === value.id);
    this.module[modelName] = this.possibleModuleFamilies[moduleFamilyIndex];
  }

  public preselectedDropdownTagFamilyValue() {
    if (!this.tagFamilies.length) {
      return [];
    } else if (null != this.activeTagFamily) {
      return [this.activeTagFamily];
    } else {
      return [this.tagFamilies[0]];
    }
  }

  public preselectedDropdownValue(modelName) {
    if (!this.module[modelName]) {
      return [{
        text: 'None',
        id: 'None'
      }];
    }
    if (this.module[modelName].treeName) {
      return [{
        text: this.module[modelName].treeName,
        id: this.module[modelName].id
      }];
    }
    return [{
      text: this.module[modelName].name,
      id: this.module[modelName].id
    }];
  }

  private buildImageUrl(partial) {
    return `${environment.BASE_URL}/${partial}`;
  }

  private mmToInch($event) {
    const mm = $event.target.value;
    this.module.housing.heightInch = (this.module.housing.height * 0.0393700787).toFixed(3);
    this.module.housing.lengthInch = (this.module.housing.length * 0.0393700787).toFixed(3);
    this.module.housing.widthInch = (this.module.housing.width * 0.0393700787).toFixed(3);
  }

  private inchToMm($event) {
    const inch = $event.target.value;
    this.module.housing.height = (this.module.housing.heightInch * 25.4).toFixed(1);
    this.module.housing.length = (this.module.housing.lengthInch * 25.4).toFixed(1);
    this.module.housing.width = (this.module.housing.widthInch * 25.4).toFixed(1);
  }

  private onCancel() {
    if (this.parentParams['showArchived'] != null) {
      this.urlOptions.showArchived = this.parentParams['showArchived'];
    }
    this.router.navigate(['/drilldown/modules', this.urlOptions]);
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this.module[input.model] = input.updatedData;
  }

  private updatePiPoModel(input) {
    const newDate = new Date(input.updatedData);

    if (!isNaN(newDate.getTime()) || input.updatedData === '') {
      const piPoIndex = this.piPoDates.findIndex(x => x.model === input.model);
      if (piPoIndex !== -1) {
        this.piPoDates[piPoIndex] = {model: input.model, updatedDate: input.updatedData};
      } else {
        this.piPoDates.push({model: input.model, updatedDate: input.updatedData});
      }
    }
  }


  private onSubmit() {
    log.d('onSubmit fired');
    log.d('number of modules:', this.numberOfSelectedFamilies());

    this.piPoDates.map((piPoDate) => {
      this.module[piPoDate.model] = piPoDate.updatedDate;
    });

    if (this.numberOfSelectedFamilies() === 0) {
      this.toast.error('Please select at least one module family!');
      return;
    }

    if (this.isVisibleSomewhere() && !this.module["image"]) {
      this.toast.error('To make the product visible, please provide an image for the module!');
      return;
    }

    this.admin.postModuleController(this.module.id, this.module).subscribe((response) => {
      // this.toast.success(`Changes have been saved.`);
      log.d('postModuleController', 'post succesfull');

      if (this.parentParams['showArchived'] != null) {
        this.urlOptions.showArchived = this.parentParams['showArchived'];
      }
      this.urlOptions.refresh = Date.now();

      this.router.navigate(['/drilldown/modules', this.urlOptions]);
    });
  }

  private numberOfSelectedFamilies(): number {

    let sum: number = 0;

    sum = sum + (this.module['family'] ? 1 : 0);
    sum = sum + (this.module['familyNa'] ? 1 : 0);
    sum = sum + (this.module['familySa'] ? 1 : 0);
    sum = sum + (this.module['familyCn'] ? 1 : 0);
    sum = sum + (this.module['familyRoa'] ? 1 : 0);

    return sum;
  }

  private isVisibleSomewhere(): boolean {
    return this.module.viewStatus == "1" ||
      this.module.viewStatusNa == "1" ||
      this.module.viewStatusSa == "1" ||
      this.module.viewStatusCn == "1" ||
      this.module.viewStatusRoa == "1";
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/module/module.component.ts